// Formatação operacional compartilhada (16-21; reutilizada por 16-12, 16-15 e 16-16):
// data/hora no fuso da planta e quantidade decimal sem passar por ponto flutuante.

const FUSO_OPERACIONAL = 'America/Sao_Paulo';
const DATA_SEM_HORA = /^(\d{4})-(\d{2})-(\d{2})$/;
const DATA_NAO_INFORMADA = 'Data não informada';
const QUANTIDADE_NAO_INFORMADA = 'Quantidade não informada';

const FORMATO_PARTES = new Intl.DateTimeFormat('pt-BR', {
  timeZone: FUSO_OPERACIONAL,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/**
 * dd/MM/yyyy HH:mm em America/Sao_Paulo. Montado por formatToParts para não depender do
 * separador entre data e hora do ICU. Data sem hora (YYYY-MM-DD, ex.: rateio diário) mostra
 * só dd/MM/yyyy: não há hora a inventar e converter UTC-meia-noite deslocaria o dia.
 */
export function formatarDataHoraOperacional(iso: string | null | undefined): string {
  if (!iso) return DATA_NAO_INFORMADA;
  const somenteData = DATA_SEM_HORA.exec(iso);
  if (somenteData) return `${somenteData[3]}/${somenteData[2]}/${somenteData[1]}`;
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return DATA_NAO_INFORMADA;
  const partes = new Map(FORMATO_PARTES.formatToParts(data).map((parte) => [parte.type, parte.value] as const));
  return `${partes.get('day')}/${partes.get('month')}/${partes.get('year')} ${partes.get('hour')}:${partes.get('minute')}`;
}

const DECIMAL = /^(-?)(\d+)(?:\.(\d+))?$/;

/**
 * Quantidade decimal vinda como string do servidor (numeric do PostgreSQL). Só manipula
 * texto: vírgula decimal, ponto de milhar, até quatro casas, zeros finais removidos.
 * Nunca converte para number (evita perda de precisão e arredondamento silencioso).
 */
export function formatarQuantidadeDecimal(valor: string | null | undefined, unidade: string | null | undefined): string {
  const texto = valor?.trim();
  const partes = texto ? DECIMAL.exec(texto) : null;
  if (!partes) return QUANTIDADE_NAO_INFORMADA;
  const [, sinal, inteiroBruto, fracaoBruta = ''] = partes;
  const inteiro = (inteiroBruto ?? '0').replace(/^0+(?=\d)/, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const fracao = fracaoBruta.slice(0, 4).replace(/0+$/, '');
  const numero = `${sinal}${inteiro}${fracao ? `,${fracao}` : ''}`;
  return `${numero} ${unidade?.trim() || 'unidade não informada'}`;
}
